<template>
  <div v-if="!fullScreen">
    <loading
      :active.sync="isLoadingLogoutEntra"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="sidebar-setting-wizard" :class="{ 'collapsed-sw': !checkToShowSettingWizardMenu}">
      <detail-setting-wizard class="sticky-top" :active="getMenuStatus" v-on:close-setting-wizard-panel="changeSettingWizard" :fetchNewSWData="fetchNewSWData"></detail-setting-wizard>
    </div>
    <div class="main-view" :class="[checkToShowSettingWizardMenu ? 'collapsed-main visible-setting-wizard-menu' : 'hidden-setting-wizard-menu']">
      <vue-header class="sticky-top" v-on:open-setting-wizard-panel="changeSettingWizard"/>
      <sub-menu v-if="!isEmbeddedPage" id="sub-menu" class="sub-menu sticky-message-top"/>
      <div :class="['container-fluid', isIgnoredPadding ? 'p-0' : '']"  :style="bodyViewHeight">
        <router-view :class="{'full-height': !isEmbeddedPage}"/>
      </div>
      <DetailMessageModalComponent :idDetailMessageModal="idDetailMessageModal" title="詳細メッセージ" :errMsges="errorMessageArray"/>
    </div>
  </div>
  <div v-else>
    <loading
      :active.sync="isLoadingLogoutEntra"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="main-view">
      <sub-menu id="sub-menu"/>
      <div class="container-fluid" :style="bodyViewHeight">
        <router-view class="full-height"/>
      </div>
      <DetailMessageModalComponent :idDetailMessageModal="idDetailMessageModal" title="詳細メッセージ" :errMsges="errorMessageArray"/>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FlashMessage from '../../common/flash-message.component'
import RouterUtils from '../../_helpers/router.util'
import WindowUtils from '../../_helpers/window.util'
import { store } from '@/store.js'
import AppConstants from '../../constants/app.constants'
import ErrorCdMsgConstants from '../../constants/error-cd-msg.constants'
import DetailMessageModalComponent from '../custom-components/DetailMessageModalComponent.vue'
import HTTPClient from '../../common/http-client'
import SocketHandler from '../../common/socket-handler'
import AlertMessageComponent from '../custom-components/AlertMessageComponent.vue'
import { SettingWizardStep } from '../../enums/setting-wizard-step.enums.js'
import DetailSettingWizard from '../custom-components/DetailSettingWizard.vue'
import { defaultHeaderTotalHeight, defaultResponsiveWidth } from '../../assets/style/_variables.scss'
import AuthUtils from '../../_helpers/auth.util'
import Loading from 'vue-loading-overlay'
const ESCAPE_KEY = 'Escape'
const IGNORED_PADDING_SCREEN_URLS = ['/mapping', '/hub-user', '/hub-setting', '/web-rcs']
// メインビューボディフルハイト
const MAIN_VIEW_BODY_FULL_HEIGHT = 100
// ボトムスペース
const BOTTOM_SPACE = 30
// 水平スクロールバーの高さ
const HORIZONTAL_SCROLL_BAR_HEIGHT = 15
export default {
  components: {
    AlertMessageComponent,
    DetailMessageModalComponent,
    DetailSettingWizard,
    Loading
  },
  data() {
    return {
      modalIds: [],
      isEmbeddedPage: false,
      dashBoardScreen: AppConstants.DASHBOARD_ROUTER_NAME,
      isIgnoredPadding: false,
      idDetailMessageModal: AppConstants.ID_MODAL_ERROR_MESSAGE_DETAIL,
      ignoreIdModal: [AppConstants.ID_MODAL_ERROR_MESSAGE_IMPORT, AppConstants.ID_MODAL_ERROR_MESSAGE_DETAIL, AppConstants.ID_MODAL_CONFIRM_DATA_USE],
      socketHandler: new SocketHandler(
        res => {
          this.processSocketMsgSettingWizard(res)
        },
        res => {
          this.processSocketMsg(res)
        },
        () => {
          FlashMessage.getInstance().setDisplayCloseIconErrMsg(false)
        },
        () => {
          if (navigator.onLine) {
            FlashMessage.getInstance().hideAllErrorMessages()
            FlashMessage.getInstance().setDisplayCloseIconErrMsg(true)
          }
        }
      ),
      isCollapsed: true,
      fetchNewSWData: false,
      mainViewBodyHeight: 0
    }
  },
  updated() {
    this.checkToRemoveScreenPadding()
    this.calculateCommonSectionsHeight()
    this.updateFullHeightFlag()
  },
  created() {
    window.addEventListener('resize', this.calculateCommonSectionsHeight)
    window.addEventListener('beforeunload', () => {
      const windowObj = WindowUtils.getWindow(AppConstants.CHUTE_GRID_WINDOW)
      // チェック クローズ ウィンドウ シュート ガード
      if (windowObj && !windowObj.closed) {
        WindowUtils.closeWindow(AppConstants.CHUTE_GRID_WINDOW)
        store.commit('setReopenChuteGridWindowFlag', 1)
      }
    })
  },
  async mounted() {
    this.$root.$on('bv::modal::show', (modal) => {
      this.modalIds.push(modal.componentId)
      if (modal && this.ignoreIdModal.includes(modal.componentId)) {
        FlashMessage.getInstance().hideAllSuccessMessages()
      } else {
        FlashMessage.getInstance().hideAllMessages()
        this.$store.commit('setModalMode', true)
      }
    })
    this.$root.$on('bv::modal::hide', (modal) => {
      if (modal && !this.ignoreIdModal.includes(modal.componentId)) {
        FlashMessage.getInstance().hideAllMessages()
        if (modal.componentId !== 'modal-confirm') {
          this.$store.commit('setModalMode', false)
        }
      }
    })
    this.$root.$on('bv::modal::hidden', () => {
      this.modalIds.pop()
    })
    this.calculateCommonSectionsHeight()
    this.updateFullHeightFlag()
    if (this.isSocketEnabled()) {
      this.socketHandler.init()
    }
    window.addEventListener('keydown', this.handleKeyDown)
    // ボディ スクロールの高さがクライアントの高さより大きい場合は、ボディ クラスに「main-body」を追加します。
    if (document.body.scrollHeight > document.body.clientHeight) {
      const classList = document.body.classList
      if (!classList.contains('main-body')) {
        classList.add('main-body')
      }
    }
    // 一般的な設定手順を完了しました。
    if (!this.getInfoSteps.includes(SettingWizardStep.GENERAL_SETTING_STEP)) {
      await this.updateSetupData({hubId: this.user.deptId, step: SettingWizardStep.GENERAL_SETTING_STEP})
    }
    window.addEventListener('offline', () => {
      FlashMessage.getInstance().showErrorMsgWithErrorCode(ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD, ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_MSG)
      FlashMessage.getInstance().setDisplayCloseIconErrMsg(false)
    })
    window.addEventListener('online', () => {
      FlashMessage.getInstance().hideAllErrorMessages()
      FlashMessage.getInstance().setDisplayCloseIconErrMsg(true)
    })
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    if (this.isSocketEnabled()) {
      this.socketHandler.close()
    }
    document.body.classList.remove('main-body')
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('resize', this.calculateCommonSectionsHeight)
    window.removeEventListener('message', this.handleMessage)
  },
  watch: {
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue) {
        this.fetchSettingData()
        this.setFetchSettingWizardFlag(false)
      }
    },
    errorMessageArray() {
      this.calculateCommonSectionsHeight()
    },
    successMessageArray() {
      this.calculateCommonSectionsHeight()
    },
    getMenuStatus() {
      // メニューの状態が変更された場合、メインビューの高さを再計算します
      // ステータス メニューが完全に閉じるまで 450 マイル待ちます
      setTimeout(() => {
        this.calculateCommonSectionsHeight()
      }, 450)
    }
  },
  methods: {
    /**
     * メインコンテンツの高さを計算します。
     * @return {string} メインビューの高さ
     */
    calculateCommonSectionsHeight() {
      if (this.isEmbeddedPage) {
        this.mainViewBodyHeight = MAIN_VIEW_BODY_FULL_HEIGHT + 'vh'
        return this.mainViewBodyHeight
      }
      let commonSectionsHeight = this.fullScreen ? 0 : +defaultHeaderTotalHeight
      const metaTag = this.$route.meta
      if (!metaTag || !metaTag.noButtonSpace) {
        commonSectionsHeight += BOTTOM_SPACE
      }
      // +48px = (32px + 16px) 32px if the container of action buttons is available and 16px (margin top/bottom)
      if (!metaTag || !metaTag.noActionButtonsContainer) {
        commonSectionsHeight += 48
      }
      // サブメニューの高さを取得し、サブメニューの警告メッセージの高さを除外します
      const subMenuElm = document.getElementById('sub-menu')
      if (subMenuElm) {
        let subMenuHeight = subMenuElm.clientHeight
        const alertMessageElm = document.getElementById('alert-message')
        if (alertMessageElm) {
          subMenuHeight -= alertMessageElm.clientHeight
        }
        commonSectionsHeight += subMenuHeight
      }
      // Return if any modal show
      if (this.$store.getters.getModalMode) {
        this.mainViewBodyHeight = commonSectionsHeight + 'px'
        return this.mainViewBodyHeight
      }
      // 現在の画面を確認し、垂直スクロールバーを表示できるようにする
      document.body.style.overflowY = 'hidden'
      // エラーメッセージがある場合
      if (this.errorMessageArray.length > 0) {
        // + メッセージの高さ
        commonSectionsHeight += FlashMessage.getInstance().getHeightOfMessage(this.errorMessageArray[0])
      }
      // 成功メッセージがあれ
      if (this.successMessageArray.length > 0) {
        // + メッセージの高さ
        commonSectionsHeight += FlashMessage.getInstance().getHeightOfMessage(this.successMessageArray[0])
      }

      // メニューが開いていてメインビューの幅が900px未満の場合
      const mainViewScroll = metaTag && metaTag.hasMainVerticalScroll
      if (document.body.clientWidth < defaultResponsiveWidth && (mainViewScroll || this.getMenuStatus)) {
        commonSectionsHeight += HORIZONTAL_SCROLL_BAR_HEIGHT
      }
      this.mainViewBodyHeight = commonSectionsHeight + 'px'
      return this.mainViewBodyHeight
    },
    handleKeyDown(event) {
      if (event.key === ESCAPE_KEY) {
        // 最後に閉じたモーダルIDを取得する
        this.$root.$emit('bv::hide::modal', this.modalIds.at(-1))
      }
    },
    updateFullHeightFlag() {
      if (window.location.href.indexOf('/hub-user') !== -1 || window.location.href.indexOf('/hub-setting') !== -1 || window.location.href.indexOf('/web-rcs') !== -1) {
        this.isEmbeddedPage = true
      } else {
        this.isEmbeddedPage = false
      }
    },
    ...mapActions('socket', ['setMessages', 'setSocketEnabledFlag', 'setFetchSettingWizardFlag']),
    ...mapActions('settingWizardStore', ['updateSetupData']),
    ...mapGetters('socket', ['isSocketEnabled']),
    /**
     * 設定ウィザードのソケットメッセージを受信します。
     */
    async processSocketMsgSettingWizard(res) {
      const resSocket = this.socketHandler.getMessage(res)
      if (resSocket && (resSocket.messages === AppConstants.SETUP_SOCKET)) {
        this.setFetchSettingWizardFlag(true)
      }
    },
    async processSocketMsg(res) {
      const message = this.socketHandler.getMessage(res)
      this.setMessages(message.messages)
    },
    async fetchSettingData() {
      const res = await HTTPClient.getInstance().http.get('/setting').catch(err => {
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
      })
      if (res && res.data) {
        this.setSocketEnabledFlag(res.data.socketEnabled)
      }
    },
    /**
     * 画面のパディングを削除する場合にチェックを入れます。
     */
    checkToRemoveScreenPadding() {
      this.isIgnoredPadding = IGNORED_PADDING_SCREEN_URLS.some((path) => window.location.href.indexOf(path) !== -1)
    },
    /**
     * 設定ウィザード パネルを変更します。
     *
     * @param fetchSWData - 設定ウィザードAPIフラグを呼び出して取得します。
     */
    changeSettingWizard(fetchSWData = false) {
      this.fetchNewSWData = fetchSWData
    },
    /**
     * ハブ ユーザーからログアウトするために期限切れのトークンをリッスンする。
     *
     * @param event イベント
     */
    handleMessage(event) {
      if (!event || !event.data) {
        return
      }

      const type = event.data.type
      const message = event.data.message
      if (message && type === AppConstants.EXPIRED_TOKEN_POST_MESSAGE) {
        AuthUtils.handleExpiredToken(message)
      }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settingWizardStore', ['getInfoSteps', 'getMenuStatus']),
    fullScreen() {
      const paramObj = RouterUtils.getUrlParam(document.location.href)
      return paramObj && paramObj.fullscreen
    },
    ...mapGetters('flashMessage', ['errorMessageArray', 'successMessageArray']),
    modalMode() {
      return this.$store.getters.getModalMode
    },
    bodyViewHeight() {
      return {
        height: `calc(${100}vh - ${this.mainViewBodyHeight || this.calculateCommonSectionsHeight()}` + ')',
        overflowY: (this.$route.meta && this.$route.meta.hasMainVerticalScroll) ? 'auto' : 'unset'}
    },
    /**
     * 作業モードがtSortか確認。
     *
     * @return {boolean} {true: ワークモードはtSortです, false: ワークモードはtSortではありません}
     */
    isTSort() {
      return store.getters.getWorkMode === AppConstants.WORK_MODE_T_SORT
    },
    /**
     * 設定ウィザードメニューを表示するにはチェックしてください。
     *
     * @return {boolean} {true: ワークモードはtSortで、メニューステータスは1です, false: ワークモードはtSortではないか、メニューステータスは0です}
     */
    checkToShowSettingWizardMenu() {
      return (this.isTSort && this.getMenuStatus)
    },
    /**
     * Entra ログアウト ローディング状態を取得します。
     *
     * @return {boolean} {true: Entra ログアウト ローディング中, false: Entra ログアウト ローディング中ではありません}
     */
    isLoadingLogoutEntra() {
      return store.getters.getIsLoadingLogoutEntra
    }
  }
}
</script>
<style lang="scss" scoped>
.sub-menu {
  padding-top: 16px;
  position: -webkit-sticky;
  position: sticky;
  top: 52px;
  z-index: 999; // this z-index value must be less than FlashMessage's z-index
}
.container-fluid {
  position: static;
  box-sizing: border-box;
  z-index: -1;
  padding-left: 16px;
  padding-right: 16px;
}
.sticky-message-top {
   position: -webkit-sticky;
   position: sticky !important;
   top: $default-header-total-height;
   z-index: 90000;
}
.full-height {
  height: 100%;
}

.sidebar-setting-wizard {
  width: $default-sw-menu-width;
  height: 100vh;
  position: absolute;
  z-index: 93000;
  top: 0;
  left: 0;
  transition: 0.45s ease-in-out;
}

.collapsed-sw {
  left: -#{$default-sw-menu-width};
}

.main-view {
  margin-left: 0px;
  transition: 0.45s ease-in-out;
  @include media-breakpoint-default() {
    &.hidden-setting-wizard-menu {
      width: $default-responsive-width;
    }

    &.visible-setting-wizard-menu {
      width: calc(#{$default-responsive-width} - #{$default-sw-menu-width});
    }
  }
  &.collapsed-main {
    margin-left: $default-sw-menu-width;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MainContent.vue